module.exports = __webpack_public_path__ + "img/l200_feel.7da3ce7f.jpg";